import Flex from "../../../../components/Flex";
import OutlineCard from "../../../../components/OutlineCard";
import Text from "../../../../components/Text";
import { useQueryParams } from "../../../../hooks/use-query-param";
import PatientForms from "../forms/PatientForms";
import { DobAuthProvider } from "./DobAuthProvider";

const PatientEmailedIntakeForm = () => {
  const patientName = useQueryParams("patientName");

  return (
    <Flex height={"100%"} width={"100%"}>
      {/* patient side bar */}
      <OutlineCard
        sx={{
          width: "256px",
          padding: 2,
          height: "100%",
        }}
        elevation={5}
      >
        <OutlineCard
          sx={{
            padding: 1,
            height: "9%",
            paddingY: 1.8,
            borderRadius: 1.4,
            bgcolor: "primary.main",
            color: "white",
          }}
          elevation={5}
        >
          <Flex gap={2} flexDirection={"column"}>
            <Flex flexDirection={"column"} gap={0.5}>
              <Text>Name:</Text>
              <Text fontWeight={"bold"}>{patientName || ""}</Text>
            </Flex>
          </Flex>
        </OutlineCard>
      </OutlineCard>

      <DobAuthProvider>
        <PatientForms publicView />
      </DobAuthProvider>
    </Flex>
  );
};

export default PatientEmailedIntakeForm;
